"use client";

import React from "react";
import { Link } from "@/components/common/Link";
import { MenuProvider, useMenu } from "@/integrations/wordpress/WordPressMenuProvider";
import { Separator } from "@/components/ui/separator";
function FooterMenuColumns() {
  const {
    menuItems,
    loading
  } = useMenu();
  if (loading) {
    return <>
        <div className="space-y-4">
          <div className="h-5 w-24 bg-muted animate-pulse rounded-sm" />
          <div className="space-y-3">
            <div className="h-4 w-32 bg-muted/50 animate-pulse rounded-sm" />
            <div className="h-4 w-28 bg-muted/50 animate-pulse rounded-sm" />
            <div className="h-4 w-36 bg-muted/50 animate-pulse rounded-sm" />
          </div>
        </div>
        <div className="space-y-4">
          <div className="h-5 w-24 bg-muted animate-pulse rounded-sm" />
          <div className="space-y-3">
            <div className="h-4 w-32 bg-muted/50 animate-pulse rounded-sm" />
            <div className="h-4 w-28 bg-muted/50 animate-pulse rounded-sm" />
            <div className="h-4 w-36 bg-muted/50 animate-pulse rounded-sm" />
          </div>
        </div>
      </>;
  }
  const half = Math.ceil((menuItems?.length || 0) / 2);
  const col1 = menuItems?.slice(0, half) || [];
  const col2 = menuItems?.slice(half) || [];
  return <>
      <div>
        <h3 className="font-semibold text-foreground mb-5 tracking-tight">Platform</h3>
        <ul className="space-y-3">
          {col1.map((item, i) => <li key={item.id} data-index={i}>
              <Link to={item.href || "#"} className="text-sm text-muted-foreground hover:text-primary transition-colors duration-200">
                {item.label}
              </Link>
            </li>)}
        </ul>
      </div>
      <div>
        <h3 className="font-semibold text-foreground mb-5 tracking-tight">Ecosystem</h3>
        <ul className="space-y-3">
          {col2.map((item, i) => <li key={item.id} data-index={i}>
              <Link to={item.href || "#"} className="text-sm text-muted-foreground hover:text-primary transition-colors duration-200">
                {item.label}
              </Link>
            </li>)}
        </ul>
      </div>
    </>;
}
export default function Footer() {
  return <section data-section-id="171085" id="footer" className="dark bg-background text-foreground py-16 lg:py-20 border-t border-border/40">
      <div className="max-w-7xl mx-auto px-4 sm:px-6 lg:px-8">
        <div className="grid grid-cols-1 md:grid-cols-2 lg:grid-cols-4 gap-12 lg:gap-8">
          
          {}
          <div className="flex flex-col items-start pr-4">
            <div className="header-logo mb-6 [--logo:url(https://wpvc-images.s3.us-east-1.amazonaws.com/images/1608524/img/cannabis_cloud_logo_v2.png)]" role="img" aria-label="Cannabis Cloud Logo" />
            <p className="text-sm text-muted-foreground leading-relaxed">
              Cannabis Cloud is the premier Salesforce solution for vertical cannabis operations, unifying retail POS, CRM, and compliance.
            </p>
          </div>

          {}
          <MenuProvider menu_id="footer_menu" className="col-span-1 md:col-span-2 grid grid-cols-1 sm:grid-cols-2 gap-8 lg:px-8">
            <FooterMenuColumns />
          </MenuProvider>

          {}
          <div className="flex flex-col items-start">
            <h3 className="font-semibold text-foreground mb-5 tracking-tight">Compliance Status</h3>
            <p className="text-sm text-muted-foreground mb-6 leading-relaxed">
              Fully integrated with Metrc and state regulatory frameworks. Real-time compliance monitoring is active.
            </p>
            <div className="inline-flex items-center gap-3 bg-card/50 px-4 py-2.5 rounded-md border border-border/50 shadow-sm backdrop-blur-sm">
              <span className="relative flex h-2.5 w-2.5">
                <span className="animate-ping absolute inline-flex h-full w-full rounded-full bg-primary opacity-75"></span>
                <span className="relative inline-flex rounded-full h-2.5 w-2.5 bg-primary"></span>
              </span>
              <span className="text-sm font-medium text-foreground tracking-tight">Metrc Connected</span>
            </div>
          </div>
          
        </div>

        <Separator className="my-10 bg-border/40" />

        {}
        <div className="flex flex-col md:flex-row justify-between items-center gap-6 text-[10px] text-muted-foreground uppercase tracking-wider">
          <p>&copy; {new Date().getFullYear()} Cannabis Cloud. All rights reserved. Subject to local regulations.</p>
          <div className="flex items-center gap-3">
            <Link to="#" className="hover:text-primary transition-colors duration-200">Privacy Policy</Link>
            <span className="text-muted-foreground/40">&middot;</span>
            <Link to="#" className="hover:text-primary transition-colors duration-200">Terms of Service</Link>
            <span className="text-muted-foreground/40">&middot;</span>
            <Link to="#" className="hover:text-primary transition-colors duration-200">Regulatory Disclosures</Link>
          </div>
        </div>
      </div>
    </section>;
}